"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "clearModal", {
  enumerable: true,
  get: function get() {
    return _clearModal["default"];
  }
});
Object.defineProperty(exports, "showModal", {
  enumerable: true,
  get: function get() {
    return _showModal["default"];
  }
});
var _showModal = _interopRequireDefault(require("./showModal"));
var _clearModal = _interopRequireDefault(require("./clearModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }